import React from 'react';
import classNames from 'classnames';
import { strings } from '@purple-start-registration/common/localization';

import { CheckBox } from '../Form';
import { formatHTML } from '../../../common/price';

function getLabels(config) {
  if (config.type === 'event') {
    return {
      paymentDescription: strings.paymentDescriptionEvents,
      paymentSummaryNothingSelected:
        strings.paymentSummaryNothingSelectedEvents,
      paymentSummaryPrice: strings.paymentSummaryPriceEvents,
    };
  }

  return {
    paymentDescription: strings.paymentDescriptionSessions,
    paymentSummaryNothingSelected:
      strings.paymentSummaryNothingSelectedSessions,
    paymentSummaryPrice: strings.paymentSummaryPriceSessions,
  };
}

export function PaymentForm({
  data,
  errors,
  handleChange,
  config,
  price,
  paymentProgress,
}) {
  const labels = getLabels(config);

  const hasPrice = price && price.totalPrice > 0;
  const disablePayment =
    !price || price.totalPrice === 0 || paymentProgress.processing;

  return (
    <div className="md:grid md:grid-cols-3 md:gap-6">
      <div className="md:col-span-1">
        <div className="px-4 sm:px-0">
          <h3 className="text-lg font-medium leading-6 text-gray-900 rsca-title">
            {strings.paymentTitle}
          </h3>
          <p className="mt-1 text-sm text-gray-600">
            {config.getTranslation('payment_description', data.language) ||
              labels.paymentDescription}
          </p>
        </div>
      </div>
      <div className="mt-5 md:mt-0 md:col-span-2">
        <div className="shadow overflow-hidden sm:rounded-md">
          <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
            <fieldset>
              <div>
                <legend className="text-base font-medium text-gray-900">
                  {strings.paymentSummaryTitle}
                </legend>
                <div className="mt-1 text-sm text-gray-700">
                  {!hasPrice && (
                    <span className="mt-1 text-sm text-gray-700">
                      {config.getTranslation(
                        'payment_nothing_selected',
                        data.language
                      ) || labels.paymentSummaryNothingSelected}
                    </span>
                  )}
                  {hasPrice && (
                    <>
                      <span
                        className="mt-1 text-sm text-gray-700"
                        dangerouslySetInnerHTML={{
                          __html: strings.formatString(
                            config.getTranslation(
                              'payment_summary_price',
                              data.language
                            ) || labels.paymentSummaryPrice,
                            price.totalSessions,
                            formatHTML(price.totalPrice)
                          ),
                        }}
                      />
                      <div className="mt-5 grid grid-cols-6 gap-3">
                        <div className="col-span-6">
                          <CheckBox
                            label={strings.acceptTerms}
                            name="accept-tos"
                            value={data.acceptTerms}
                            errorMessage={errors.acceptTerms}
                            handleChange={handleChange('acceptTerms')}
                          />
                        </div>

                        <div className="col-span-6">
                          <CheckBox
                            label={strings.registerNewsletter}
                            name="newsletter"
                            value={data.registerNewsletter}
                            handleChange={handleChange('registerNewsletter')}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {paymentProgress.error && (
                  <p
                    className="mt-2 text-sm text-red-600"
                    dangerouslySetInnerHTML={{
                      __html: paymentProgress.error,
                    }}
                  />
                )}
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  disabled={disablePayment}
                  className={classNames(
                    'inline-flex',
                    'justify-center',
                    'py-2',
                    'px-4',
                    'border',
                    'border-transparent',
                    'shadow-sm',
                    'text-sm',
                    'font-medium',
                    'rounded-md',
                    'text-white',
                    'focus:outline-none',
                    'focus:ring-2',
                    'focus:ring-offset-2',
                    'focus:ring-purple-500',
                    {
                      'bg-purple-200': disablePayment,
                      'bg-purple-600': !disablePayment,
                      'hover:bg-purple-200': disablePayment,
                      'hover:bg-purple-700': !disablePayment,
                    }
                  )}
                >
                  {paymentProgress.processing && (
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  )}
                  {strings.paymentButton}
                </button>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  );
}
